import { render, staticRenderFns } from "./EditTradePassword.vue?vue&type=template&id=33f4e52b&scoped=true"
import script from "./EditTradePassword.vue?vue&type=script&lang=js"
export * from "./EditTradePassword.vue?vue&type=script&lang=js"
import style0 from "./EditTradePassword.vue?vue&type=style&index=0&id=33f4e52b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f4e52b",
  null
  
)

export default component.exports